<div class="p-10 h-full">
    <nz-page-header class="text-[16px] font-semibold p-0 pb-2 m-0" nzTitle="Máquinas">
        <nz-page-header-extra class="flex">
            <nz-space>
                @if (canCreate()) {
                <button class="button primary-button" (click)="createMachine()">
                    Añadir
                </button>
                }
            </nz-space>
        </nz-page-header-extra>
    </nz-page-header>

    <nz-table #machinesTable nzTableLayout="auto" nzSize="small" [nzData]="machines" [nzLoading]="isLoading"
        [nzLoadingIndicator]="indicatorTemplate" [nzBordered]="true">
        <thead>
            <tr>
                <th nzWidth="300px">Nombre</th>
                <th nzWidth="300px">Dirección IP</th>
                <th nzWidth="300px">Nombre de la cola</th>
                <th nzWidth="300px">Estado</th>
                @if (canRead() || canEdit() || canDelete()) {
                <th nzWidth="200px" id="actions">Acciones</th>
                }
            </tr>
        </thead>
        <tbody>
            @for (data of machinesTable.data; track idx; let idx = $index) {
            <tr>
                <td>{{ data.name }}</td>
                <td>{{ data.ip }}</td>
                <td>{{ data.queueName }}</td>
                <!--TODO: CHANGE TO CSS CLASS DEPENDS ON STATUS OF MACHINE LIKE ORDERS VIEW-->
                <td>
                    <div class="flex align-middle justify-center">
                        <span [ngClass]="{
                                    'bg-status-in-progress': data.state === machineStatesEnum.RUNNING,
                                    'bg-status-finished': data.state === machineStatesEnum.MAINTENANCE,
                                    'bg-status-awaiting': data.state === machineStatesEnum.AVAILABLE,
                                    'bg-status-offline': data.state === machineStatesEnum.OFFLINE
                                }" class="text-white text-xs px-2 py-1 rounded-lg">
                            {{data.state}}
                        </span>
                    </div>
                </td>
                @if (canRead() || canEdit() || canDelete()) {
                <td>
                    <div class="flex align-middle justify-center">
                        @if (canRead()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Ver máquina'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="view(data)">
                            <span nz-icon nzType="eye"></span>
                        </button>
                        @if (canEdit() || canDelete()) {
                        <nz-divider nzType="vertical"></nz-divider>
                        }
                        }

                        @if (canEdit()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Editar máquina'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="edit(data)">
                            <span nz-icon nzType="edit"></span>
                        </button>
                        @if (canDelete()) {
                        <nz-divider nzType="vertical"></nz-divider>
                        }
                        }

                        @if (canDelete()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Eliminar máquina'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="delete(data.id)">
                            <span nz-icon nzType="delete"></span>
                        </button>
                        }
                    </div>
                </td>
                }
            </tr>
            }
        </tbody>
    </nz-table>
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<nz-drawer [nzClosable]="false" [nzVisible]="drawerVisible" nzPlacement="right" [nzTitle]="title" [nzFooter]="footer"
    (nzOnClose)="closeDrawer()" [nzPlacement]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'right':'bottom'"
    [nzWidth]="'500px'" [nzHeight]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? '' : '90%'"
    [nzMaskClosable]="fieldsReadOnly">
    <ng-template #title class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
        <div style="display: flex; align-items: center;">
            <p class="drawer-title"> {{ drawerTitle }} </p>
        </div>
    </ng-template>
    <ng-container *nzDrawerContent>
        <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                    <nz-form-label nzRequired>
                        Nombre
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique el nombre para la máquina">
                        <input onfocus="select()" nz-input placeholder="Indique un nombre para la máquina" type="text"
                            id="name" formControlName="name" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                    <nz-form-label nzRequired>
                        Dirección IP
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique una dirección IP válida para la máquina">
                        <input onfocus="select()" nz-input placeholder="Indique una dirección IP para la máquina"
                            type="text" id="ip" formControlName="ip" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                    <nz-form-label nzRequired>
                        Nombre de la cola
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique un nombre de la cola para la máquina">
                        <input onfocus="select()" nz-input placeholder="Indique un nombre de la cola para la máquina"
                            type="text" id="queueName" formControlName="queueName" />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </form>
    </ng-container>
    <ng-template #footer>
        <div class="flex justify-end">
            <button class="button secondary-button mr-2" (click)="cancelEditing()">
                Cancelar
            </button>

            @if (!fieldsReadOnly) {
                <button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
                    Guardar
                </button>
            }
        </div>
    </ng-template>
</nz-drawer>